import React, { useState, useEffect } from "react";
import styles from './Browse.module.css'
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CTASection from "../Home/sections/CTASection";

const services = [
    {
        id: 1,
        image: "/images/service1.png",
        agentAvatar: "/images/1.svg",
        agentName: "Grace Helen",
        title: "Book Restaurant Reservations in Lagos",
        rating: 4.9,
        reviewCount: 234,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 2,
        image: "/images/service2.png",
        agentAvatar: "/images/2.svg",
        agentName: "Temitope Monday",
        title: "Airport Pickup & Drop-off Arrangement",
        rating: 4.7,
        reviewCount: 134,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 3,
        image: "/images/service3.png",
        agentAvatar: "/images/3.svg",
        agentName: "George Federick",
        title: "Personal Shopping Assistant",
        rating: 4.7,
        reviewCount: 24,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 4,
        image: "/images/service4.png",
        agentAvatar: "/images/1.svg",
        agentName: "Bola Ahmed",
        title: "Travel Itinerary Planning",
        rating: 5.0,
        reviewCount: 414,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 2,
        image: "/images/service2.png",
        agentAvatar: "/images/2.svg",
        agentName: "Temitope Monday",
        title: "Airport Pickup & Drop-off Arrangement",
        rating: 4.7,
        reviewCount: 134,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 3,
        image: "/images/service3.png",
        agentAvatar: "/images/3.svg",
        agentName: "George Federick",
        title: "Personal Shopping Assistant",
        rating: 4.7,
        reviewCount: 24,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 1,
        image: "/images/service1.png",
        agentAvatar: "/images/1.svg",
        agentName: "Grace Helen",
        title: "Book Restaurant Reservations in Lagos",
        rating: 4.9,
        reviewCount: 234,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 2,
        image: "/images/service2.png",
        agentAvatar: "/images/2.svg",
        agentName: "Temitope Monday",
        title: "Airport Pickup & Drop-off Arrangement",
        rating: 4.7,
        reviewCount: 134,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 3,
        image: "/images/service3.png",
        agentAvatar: "/images/3.svg",
        agentName: "George Federick",
        title: "Personal Shopping Assistant",
        rating: 4.7,
        reviewCount: 24,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 4,
        image: "/images/service4.png",
        agentAvatar: "/images/1.svg",
        agentName: "Bola Ahmed",
        title: "Travel Itinerary Planning",
        rating: 5.0,
        reviewCount: 414,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 2,
        image: "/images/service2.png",
        agentAvatar: "/images/2.svg",
        agentName: "Temitope Monday",
        title: "Airport Pickup & Drop-off Arrangement",
        rating: 4.7,
        reviewCount: 134,
        location: "Lagos, Nigeria",
        price: 15000,
    },
    {
        id: 3,
        image: "/images/service3.png",
        agentAvatar: "/images/3.svg",
        agentName: "George Federick",
        title: "Personal Shopping Assistant",
        rating: 4.7,
        reviewCount: 24,
        location: "Lagos, Nigeria",
        price: 15000,
    },
];

const categories = [
    "All",
    "Errand Running",
    "Travel Assistance",
    "Restaurant Reservation",
    "Personal Shopping",
    "Event Planning",
    "Corporate Support",
    "Lifestyle"
];



function Browse() {
    const [activeCategory, setActiveCategory] = useState("All");

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(6);

    const filteredServices = activeCategory === "All"
        ? services
        : services.filter(service =>
            service.title.toLowerCase().includes(activeCategory.toLowerCase())
        );

    const totalItems = filteredServices.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

    const currentServices = filteredServices.slice(startIndex, endIndex);

    useEffect(() => {
        setCurrentPage(1);
    }, [activeCategory]);

    return (
        <main>
            <section className={styles.searchContainer}>

                <div className={styles.searchFilter}>

                    <div className={styles.searchBar}>
                        <img src="/images/search.svg" alt="search" className={styles.searchIcon} />
                        <input type="text" placeholder="Search Concierge Services..." />
                    </div>

                    {/* Filter Pills */}
                    <div className={styles.filterRow}>
                        {categories.map((category) => (
                            <button
                                key={category}
                                className={`${styles.pill} ${activeCategory === category ? styles.pillActive : ""}`}
                                onClick={() => setActiveCategory(category)}
                            >
                                {category}
                            </button>
                        ))}

                    </div>

                    {/* Mobile Filter Dropdowns - hidden on desktop */}
                    <div className={styles.mobileFilters}>
                        <select className={styles.mobileSelect}>
                            <option value="">Location</option>
                            <option value="lagos">Lagos, Nigeria</option>
                            <option value="abuja">Abuja</option>
                            <option value="worldwide">Worldwide</option>
                        </select>

                        <select className={styles.mobileSelect}>
                            <option value="">Price Range</option>
                            <option value="under25000">Under ₦25,000</option>
                            <option value="25000-50000">₦25,000 - ₦50,000</option>
                            <option value="over50000">Over ₦50,000</option>
                        </select>

                        <select className={styles.mobileSelect}>
                            <option value="">Minimum Rating</option>
                            <option value="3">⭐⭐⭐</option>
                            <option value="4">⭐⭐⭐⭐</option>
                            <option value="5">⭐⭐⭐⭐⭐</option>
                        </select>
                    </div>

                </div>

                <div className={styles.filterContainer}>

                    <div className={styles.filterInformation}>

                        <form className={styles.filterInfo}>

                            {/* Location */}
                            <div className={styles.filterGroup}>
                                <h4>Location</h4>
                                <label>
                                    <input type="radio" name="location" value="lagos" />
                                    Lagos, Nigeria
                                </label>
                                <label>
                                    <input type="radio" name="location" value="abuja" />
                                    Abuja
                                </label>
                                <label>
                                    <input type="radio" name="location" value="worldwide" />
                                    Worldwide
                                </label>
                            </div>

                            {/* Price Range */}
                            <div className={styles.filterGroup}>
                                <h4>Price Range</h4>
                                <label>
                                    <input type="radio" name="price" value="under25000" />
                                    Under ₦25,000
                                </label>
                                <label>
                                    <input type="radio" name="price" value="25000-50000" />
                                    ₦25,000 - ₦50,000
                                </label>
                                <label>
                                    <input type="radio" name="price" value="over50000" />
                                    Over ₦50,000
                                </label>
                            </div>

                            {/* Minimum Rating */}
                            <div className={styles.filterGroup}>
                                <h4>Minimum Rating</h4>
                                <label>
                                    <input type="radio" name="rating" value="3" />
                                    4.5+ <span>★</span>
                                </label>
                                <label>
                                    <input type="radio" name="rating" value="4" />
                                    4.0+ <span>★</span>
                                </label>
                                <label>
                                    <input type="radio" name="rating" value="5" />
                                    3.5+ <span>★</span>
                                </label>
                            </div>

                        </form>

                    </div>

                    <div className={styles.availableService}>
                        <p className={styles.foundServices}>
                            <strong>{filteredServices.length}</strong> Services found
                        </p>

                        {/* ADDITION: Empty state outside serviceRow so it takes full width */}
                        {filteredServices.length === 0 ? (
                            <div className={styles.emptyState}>
                                <img src="/images/non.png" alt="No services found" />
                            </div>
                        ) : (
                            <div className={styles.serviceRow}>
                                {currentServices.map((service, index) => (
                                    <ServiceCard
                                        key={index}
                                        image={service.image}
                                        agentAvatar={service.agentAvatar}
                                        agentName={service.agentName}
                                        title={service.title}
                                        rating={service.rating}
                                        reviewCount={service.reviewCount}
                                        location={service.location}
                                        price={service.price}
                                    />
                                ))}
                            </div>
                        )}

                        {totalItems > 0 && (
                            <div className={styles.paginationContainer}>
                                <div className={styles.pageInfo}>
                                    Showing Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
                                </div>

                                <div className={styles.pageControls}>
                                    <span className={styles.perPageLabel}>Per Page</span>
                                    <select
                                        className={styles.perPageSelect}
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(Number(e.target.value));
                                            setCurrentPage(1); // Reset to page 1 on limit change
                                        }}
                                    >
                                        <option value={6}>6</option>
                                        <option value={12}>12</option>
                                        <option value={24}>24</option>
                                    </select>

                                    <div className={styles.arrowGroup}>
                                        <button
                                            className={styles.arrowBtn}
                                            onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                                            disabled={currentPage === 1}
                                        >
                                            &lt;
                                        </button>
                                        <button
                                            className={styles.arrowBtn}
                                            onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                                            disabled={currentPage === totalPages}
                                        >
                                            &gt;
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </section>

            <CTASection />
        </main>
    );
}
export default Browse